import { ATLEAST_N, ATMOST_N } from '@portals/shared/common/messages';
import { z } from 'zod';

import { ApiLifeCycleRequest } from '@/openapi/schema';

const API_STAGES = [
  'UPCOMING',
  'LAUNCHED',
  'DEPRECATED',
  'DECOMMISSIONED',
] as const satisfies readonly ApiLifeCycleRequest['stage'][];

export const apiLifecycleSchema = z
  .object({
    stage: z.enum(API_STAGES),
    stageMessage: z.preprocess(
      (value) => value ?? null,
      z.string().min(10, ATLEAST_N(10)).max(255, ATMOST_N(255)).or(z.null()),
    ),
  })
  .refine((data) => !((data.stage === 'DEPRECATED' || data.stage === 'DECOMMISSIONED') && data.stageMessage === null), {
    message: 'A message is required for deprecated or decommissioned stages',
    path: ['stageMessage'],
  });
